export default "__VITE_ASSET__DLryq_Qc__"